import { BaseCachePayload } from "../base-cache.payload";

export class UserCachePayload extends BaseCachePayload { }
